import { useEffect, useMemo } from 'react';
import { t } from 'i18next';
import { useInicisBillingPayment } from './hooks/useInicisBillingPayment';
import { ReactComponent as BlueArrowRightIcon } from '../../icons/blue.arrow.right.svg';

const PaymentBillingPage = () => {
  const searchParams = useMemo(() => new URLSearchParams(window.location.search), []);

  const amount = searchParams.get('amount') ?? '';
  const productName = searchParams.get('productName') ?? '';
  const productId = searchParams.get('productId') ?? '';

  const { handleCreateOrder } = useInicisBillingPayment({
    amount,
    productName,
    productId
  });

  useEffect(() => {
    if (productId && amount && productName) {
      void handleCreateOrder();
    }
  }, [productId, amount, productName, handleCreateOrder]);

  useEffect(() => {
    const timer = setTimeout(() => {
      window.close();
    }, 5000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col gap-[38px] items-center justify-center">
      <BlueArrowRightIcon width={65} height={65} />
      <p className="text-[24px] font-semibold text-text-main-lv2 leading-[28px] text-center">
        {t('InicisPaymentLaunch.moveToPayment')}
      </p>
    </div>
  );
};

export default PaymentBillingPage;
